import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import socketSetup from "../../socket-io/socket-io";
import { clientApiSlice } from "../../features/client/clientApiSlice";
import { orderApiSlice } from "../../features/order/orderApiSlice";
import { selectCurrentUserClientID } from "../../features/auth/authSlice";
import { guestApiSlice } from "../../features/guest/guestApiSlice";

interface SocketPayload {
    clientId: number;
}

export const useOrderSocket = () => {
    const dispatch = useDispatch();
    const currentClientId = useSelector(selectCurrentUserClientID)
    const invalidateOrder = useCallback(
        ({ clientId }: SocketPayload) => {
            dispatch(
                orderApiSlice.util.invalidateTags([
                    { type: 'Cart', id: 'LIST' },
                    { type: 'Orders', id: 'LIST' },
                    { type: 'Client', id: 'LIST' },
                    { type: 'ClientProduct', id: 'LIST' },
                ])
            );
            dispatch(
                clientApiSlice.util.invalidateTags([
                    { type: 'Cart', id: 'LIST' },
                    { type: 'Orders', id: 'LIST' },
                    { type: 'Client', id: 'LIST' },
                    { type: 'ClientProduct', id: 'LIST' },
                ])
            );
            dispatch(
                guestApiSlice.util.invalidateTags([
                    { type: 'Cart', id: 'LIST' },
                    { type: 'Orders', id: 'LIST' },
                    { type: 'Client', id: 'LIST' },
                    { type: 'ClientProduct', id: 'LIST' },
                ])
            );
            if (clientId !== currentClientId) return;
            dispatch(clientApiSlice.util.invalidateTags([
                    { type: "Cart", id: clientId },
                    { type: "Orders", id: clientId },
                    { type: "Client", id: clientId },
                    { type: "ClientProduct", id: clientId },
                ])
            );
            dispatch(guestApiSlice.util.invalidateTags([
                    { type: "Cart", id: clientId },
                    { type: "Orders", id: clientId },
                    { type: "Client", id: clientId },
                    { type: "ClientProduct", id: clientId },
                ])
            );
        },
        [dispatch, currentClientId]
    );

    useEffect(() => {
        if (!socketSetup) return;

        socketSetup.on("checkout", invalidateOrder); 
        socketSetup.on("placeOrder", invalidateOrder); 
        socketSetup.on("updateOrderStatus", invalidateOrder); 
        socketSetup.on("cancelOrderBySession", invalidateOrder); 
        socketSetup.on("updateClient", invalidateOrder); 
        socketSetup.on("addSpecialPackage", invalidateOrder); 
        socketSetup.on("createAddon", invalidateOrder); 
        socketSetup.on("updateAddon", invalidateOrder); 
        socketSetup.on("updateProduct", invalidateOrder); 
        socketSetup.on("updateStatus", invalidateOrder); 

        return () => {
            socketSetup.off("checkout", invalidateOrder); 
            socketSetup.off("placeOrder", invalidateOrder); 
            socketSetup.off("updateOrderStatus", invalidateOrder); 
            socketSetup.off("cancelOrderBySession", invalidateOrder); 
            socketSetup.off("updateClient", invalidateOrder); 
            socketSetup.off("addSpecialPackage", invalidateOrder); 
            socketSetup.off("createAddon", invalidateOrder); 
            socketSetup.off("updateAddon", invalidateOrder); 
            socketSetup.off("updateProduct", invalidateOrder); 
            socketSetup.off("updateStatus", invalidateOrder); 
        };
    }, [invalidateOrder]);
}

